import { ReactElement, useEffect, useState } from 'react';

import { useHirePlanForm } from '../../../../contexts/HirePlanFormProviderGdf';
import { Input } from '../../../Input';
import { GoForwardButton } from '../../GoForwardButton';
import { useRouteLoaderData } from 'react-router-dom';
import { isValidCPF } from '../../../../utils/ValidarCPF';

export function ServidorValidationForm(): ReactElement {
  const { register, handleSubmit, goToNextForm, errors, watch, setValue } =
    useHirePlanForm();
  const initialPlanData: any = useRouteLoaderData('token-servidor');
  const produtosGDF = [993, 994, 998, 999, 1000];
  const [error, setError] = useState<string | null>(null);

  const Matricula = watch('valida.matricula');
  const CPF = watch('valida.cpf');

  const [showError, setShowError] = useState(false);

  const validaDados = async () => {
    if (
      !CPF ||
      (produtosGDF.includes(initialPlanData?.produtoComercial?.id_prodcomerc) &&
        !Matricula)
    ) {
      handleSubmit(goToNextForm)();
      return false;
    }

    if (!isValidCPF(CPF)) {
      setError('CPF inválido');
      setShowError(true);

      setTimeout(() => {
        setShowError(false);
      }, 5000);

      return false;
    }

    if (
      initialPlanData?.produtoComercial?.id_categoria_c === 2 &&
      !produtosGDF.includes(initialPlanData?.produtoComercial?.id_prodcomerc)
    ) {
      console.log('getCPFDetailsAssertiva');
      await getCPFDetailsAssertiva(CPF);
      setError(null);
      handleSubmit(goToNextForm)();
      return true;
    }

    const verify = await getCPFDetails(CPF, Matricula);

    const Validation = watch('valida.validation.retorno');
    if (!Validation || verify.error) {
      setError(
        'As informações não são suficientes para sua identificação como servidor do GDF;\nEntre em contato conosco pelo 40072028',
      );
      setShowError(true);

      setTimeout(() => {
        setShowError(false);
      }, 5000);
    } else {
      console.log('aqui: ', Validation);
      setError(null);
      handleSubmit(goToNextForm)();
      return true;
    }
  };

  const handleChangeMatricula = e => {
    let val = e.target.value.replace(/[.\-\s]/g, '');
    val = val.slice(-8);
    const padded = val.padStart(8, '0');
    setValue('valida.matricula', padded);
  };

  const getCPFDetails = async (cpf: string, matricula: string) => {
    const formatedCpf = cpf.replace(/[.\-\s]/g, '');
    const formatedMatricula = matricula.replace(/[.\-\s]/g, '');
    const getAssociado = await fetch(
      `${process.env.REACT_APP_OG_GET_ASSOCIADO_CPF}?cpf=${formatedCpf}
      &matricula=${formatedMatricula}`,
    ).then(response => response.json());
    if (getAssociado.cpf) {
      setValue('valida.validation.retorno', getAssociado);
    }
    return getAssociado;
  };

  const getCPFDetailsAssertiva = async (cpf: string) => {
    const formatedCpf = cpf.replace(/[.\-\s]/g, '');
    const getAssociado = await fetch(
      `${process.env.REACT_APP_OG_API_URL}/info/getAssertiva?cpf=${formatedCpf}`,
    ).then(response => response.json());
    if (getAssociado.cpf) {
      setValue('valida.validation.retorno', getAssociado);
    }
    return getAssociado;
  };

  return (
    <form
      action=""
      className="max-w-[766px] w-full"
      onSubmit={handleSubmit(validaDados)}
    >
      <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
        Dados
      </h2>

      <div className="grid min-[748px]:grid-cols-2 grid-cols-1 gap-6">
        <Input
          label="CPF"
          placeholder="CPF"
          activateMask
          mask="999.999.999-99"
          errorMessage={errors.valida?.cpf?.message}
          {...register('valida.cpf')}
        />
        {produtosGDF.includes(
          initialPlanData?.produtoComercial?.id_prodcomerc,
        ) && (
          <Input
            label="matricula"
            placeholder="matricula"
            errorMessage={errors.valida?.matricula?.message}
            {...register('valida.matricula')}
            onChange={handleChangeMatricula}
          />
        )}
      </div>

      {showError && (
        <div className="fixed top-24 left-1/2 transform -translate-x-1/5 bg-red-500 text-white py-2 px-4 rounded shadow-md">
          <p className="text-sm font-medium">
            {error?.split('\n').map((line, index) => (
              <span key={index}>
                {line}
                <br />
              </span>
            ))}
          </p>
        </div>
      )}

      <GoForwardButton onForwardClick={validaDados} />
    </form>
  );
}
